import { Modal as ModalModule, Utils } from 'common';
import React from 'react';

const { Modal, ModalButtonActionType } = ModalModule;
const { Session, Util } = Utils;

const GBBPlanChangedSuccessfulModal = ({ modalId, data }) => {
	const { newPlanCost, isUpgrade } = data;
	const { BillingDayOfMonth, CurrentServiceFees } =
		Session.getInternalAccountInfo();
	const contactNumber = Util.getFraudNumber();

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'OK',
		dataqa: 'gbb-plan-change-successful-ok-button',
	};

	const renderFooter = () => (
		<div className="footer">
			<span className="message-icon" />
			<p className="footer-text">
				<a
					href={'https://help.stamps.com/hc/en-us/articles/20821937508379'}
					target="_blank"
					rel="noopener noreferrer"
				>
					Learn more about your subscriptions, plans, and billing cycles
				</a>{' '}
				, or contact support with your questions at {contactNumber},
				Monday-Friday 8 am - 8 pm Central Time.
			</p>
		</div>
	);

	const planChangeText = () => {
		const billingDate = Util.getBillingDate(BillingDayOfMonth);
		const nextDayBillingDate = Util.getNextDay(billingDate);

		if (isUpgrade) {
			return (
				<div className="plan-change-info">
					<p className="section1">
						You can start using your new plan features in just a few minutes.
					</p>
					<p className="section2">
						Here are a few things to keep in mind about your billing cycles:
					</p>
					<div className="list">
						<ul>
							<li>
								Stamps.com bills at the end of the billing cycle for the prior
								month of service
							</li>
							<li>
								Your next bill will reflect your prior plan cost ($
								{CurrentServiceFees}) + a prorated amount for your new plan
								selection
							</li>
							<li>
								The following bills will reflect your new plan cost ($
								{newPlanCost}) + applicable taxes, if any
							</li>
						</ul>
					</div>
					{renderFooter()}
				</div>
			);
		} else {
			return (
				<div className="plan-change-info">
					<p className="section1">
						Your new plan will go into effect on the first day of your next
						billing cycle {nextDayBillingDate}.
					</p>
					<p className="section2">
						Here are a few things to keep in mind about your billing cycles:
					</p>
					<div className="list">
						<ul>
							<li>
								Stamps.com bills at the end of the billing cycle for the prior
								month of service
							</li>
							<li>
								Your next bill will reflect your prior plan cost{' '}
								{CurrentServiceFees}
							</li>
							<li>
								The following bills will reflect your new plan cost $
								{newPlanCost} + applicable taxes, if any
							</li>
						</ul>
					</div>
					{renderFooter()}
				</div>
			);
		}
	};

	return (
		<Modal
			modalId={modalId}
			className="account-change-plan gbb-plan-changed-succesful-modal"
			header="Plan Change Successful!"
			primaryButton={primaryButton}
		>
			<div className="body">{planChangeText()}</div>
		</Modal>
	);
};

export default GBBPlanChangedSuccessfulModal;
